webpackJsonp([213534597649335],{

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _reactGa = __webpack_require__(22);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(3);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    button: {
	      borderRadius: "3px",
	      marginTop: "1rem",
	      marginLeft: "0.5rem",
	      marginRight: "0.5rem",
	      minWidth: "48px",
	      width: "auto",
	      padding: "1rem",
	      color: theme.colours.palette.white,
	      fontWeight: 400,
	      textDecoration: "none",
	      textAlign: "center",
	      boxShadow: "2px 2px 5px #888888",
	      "&:hover": {
	        transform: "translate(2px, 2px)",
	        webkitTransform: "translate(2px, 2px)",
	        mozTransform: "translate(2px, 2px)",
	        oTransform: "translate(2px, 2px)",
	        msTransform: "translate(2px, 2px)",
	        boxShadow: "0 0 0"
	      },
	      "@media (max-width: 1024px)": {
	        padding: "0.5rem",
	        minWidth: "24px",
	        marginLeft: "0.25rem",
	        marginRight: "0.25rem",
	        fontSize: "1rem"
	      }
	    }
	  };
	};
	
	var Button = function Button(_ref) {
	  var classes = _ref.classes,
	      label = _ref.label,
	      linkUrl = _ref.linkUrl,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? "" : _ref$className;
	  return _react2.default.createElement(
	    _reactGa.OutboundLink,
	    {
	      className: classes.button + " " + className,
	      to: linkUrl,
	      eventLabel: label + " \" button\""
	    },
	    label
	  );
	};
	
	Button.propTypes = {
	  classes: _propTypes2.default.object,
	  label: _propTypes2.default.string.isRequired,
	  linkUrl: _propTypes2.default.string.isRequired,
	  className: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(Button);
	module.exports = exports["default"];

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Row = __webpack_require__(128);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonRow = function ButtonRow(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    _Row2.default,
	    { middle: true, center: true },
	    children
	  );
	};
	
	ButtonRow.propTypes = {
	  children: _propTypes2.default.node
	};
	
	exports.default = ButtonRow;
	module.exports = exports["default"];

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Button = undefined;
	
	var _Button = __webpack_require__(193);
	
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Button).default;
	  }
	});
	
	var _ButtonRow = __webpack_require__(194);
	
	var _ButtonRow2 = _interopRequireDefault(_ButtonRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ButtonRow2.default;

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var govButtons = ["Councillor", "Group", "Council", "Department"];
	
	exports.default = govButtons;
	module.exports = exports["default"];

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var voterButtons = ["Candidate", "Campaign", "Party"];
	
	exports.default = voterButtons;
	module.exports = exports["default"];

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Hero-home.fc92b020.jpg";

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Map-home.b4f24827.png";

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.HomeQuery = undefined;
	
	var _ButtonRow = __webpack_require__(195);
	
	var _ButtonRow2 = _interopRequireDefault(_ButtonRow);
	
	var _Grid = __webpack_require__(5);
	
	var _Hero = __webpack_require__(13);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _ContentBlock = __webpack_require__(6);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _HtmlContainer = __webpack_require__(8);
	
	var _HtmlContainer2 = _interopRequireDefault(_HtmlContainer);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextSection = __webpack_require__(7);
	
	var _TextSection2 = _interopRequireDefault(_TextSection);
	
	var _Video = __webpack_require__(50);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _HomeGovButtons = __webpack_require__(208);
	
	var _HomeGovButtons2 = _interopRequireDefault(_HomeGovButtons);
	
	var _reactJss = __webpack_require__(3);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _HomeVoterButtons = __webpack_require__(209);
	
	var _HomeVoterButtons2 = _interopRequireDefault(_HomeVoterButtons);
	
	var _HeroHome = __webpack_require__(494);
	
	var _HeroHome2 = _interopRequireDefault(_HeroHome);
	
	var _MapHome = __webpack_require__(506);
	
	var _MapHome2 = _interopRequireDefault(_MapHome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    greenButton: {
	      backgroundColor: theme.colours.products.mp
	    },
	    purpleButton: {
	      backgroundColor: theme.colours.products.scot
	    },
	    orangeButton: {
	      backgroundColor: theme.colours.products.mla
	    },
	    blueButton: {
	      backgroundColor: theme.colours.palette.blue
	    },
	    redButton: {
	      backgroundColor: theme.colours.products.td
	    },
	    yellowButton: {
	      backgroundColor: theme.colours.palette.yellow
	    },
	    pinkButton: {
	      backgroundColor: theme.colours.palette.pink
	    },
	    whiteContent: {
	      backgroundColor: theme.colours.palette.white,
	      minHeight: "40vh"
	    },
	    textBox: {
	      maxWidth: "35vw",
	      "& h1": {
	        fontSize: "3.6rem",
	        textAlign: "center",
	        fontWeight: 100,
	        margin: 0,
	        "@media (max-width: 823px)": {
	          fontSize: "2.2rem"
	        }
	      },
	      "@media (max-width: 823px)": {
	        fontSize: "1rem",
	        maxWidth: "75vw"
	      }
	    },
	    contentBox: {
	      minHeight: "40vh"
	    },
	    container: {
	      width: "100%"
	    },
	    noMobile: {
	      "@media (max-width: 823px)": {
	        display: "none"
	      }
	    },
	    mobile: {
	      "@media (min-width: 824px)": {
	        display: "none"
	      }
	    },
	    video: {
	      "@media (max-width: 823px)": {
	        display: "none"
	      },
	      // iPad portrait mode
	      "@media (min-width: 824px) and (max-width: 1400px)": {
	        width: "400px",
	        height: "225px"
	      }
	    },
	    mobileVideo: {
	      marginTop: "2rem",
	      width: "90vw",
	      height: "50vw",
	      // Phone landscape
	      "@media (orientation: landscape)": {
	        width: "160vh",
	        height: "90vh"
	      },
	      "@media (min-width: 767px) and (max-width: 769px)": {
	        height: "30vh"
	      },
	      "@media (min-width: 824px)": {
	        display: "none"
	      }
	    },
	    voterImage: {
	      width: "450px",
	      "@media (max-width: 823px)": {
	        display: "none"
	      }
	    },
	    voterMobileImage: {
	      marginTop: "2rem",
	      width: "300px",
	      "@media (min-width: 824px)": {
	        display: "none"
	      }
	    },
	    logo: {
	      height: "29vh",
	      maxHeight: "400px"
	    },
	    heroText: {
	      topMargin: "1.5rem"
	    }
	  };
	};
	
	var HomePage = function HomePage(_ref) {
	  var data = _ref.data,
	      classes = _ref.classes;
	  return _react2.default.createElement(
	    "div",
	    { className: classes.page },
	    _react2.default.createElement(
	      _Hero2.default,
	      { hero: _HeroHome2.default },
	      _react2.default.createElement(
	        _Grid.Row,
	        { center: true, top: true },
	        _react2.default.createElement(
	          _Hero.HeroText,
	          null,
	          _react2.default.createElement(_HtmlContainer2.default, {
	            className: classes.heroText,
	            content: data.HeroText.html
	          }),
	          _react2.default.createElement("img", { src: "/EtechLogo_NoText.png", className: classes.logo })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox, id: "features" },
	      _react2.default.createElement(
	        "div",
	        { className: classes.container },
	        _react2.default.createElement(
	          "div",
	          { className: classes.noMobile },
	          _react2.default.createElement(
	            _Grid.Row,
	            { around: true, middle: true },
	            _react2.default.createElement(_Video2.default, {
	              name: "Caseworker.mp Video",
	              className: classes.video,
	              src: "//www.youtube.com/embed/tKMXw7BJhck?rel=0&showinfo=0"
	            }),
	            _react2.default.createElement(
	              _Grid.Col,
	              { middle: true, center: true },
	              _react2.default.createElement(
	                _TextSection2.default,
	                { className: classes.textBox },
	                _react2.default.createElement(_HtmlContainer2.default, { content: data.FirstContentSection.html })
	              ),
	              _react2.default.createElement(
	                _ButtonRow2.default,
	                null,
	                _react2.default.createElement(_ButtonRow.Button, {
	                  className: classes.greenButton,
	                  linkUrl: "/mp",
	                  label: "MP"
	                }),
	                _react2.default.createElement(_ButtonRow.Button, {
	                  className: classes.purpleButton,
	                  linkUrl: "/scot",
	                  label: "MSP"
	                }),
	                _react2.default.createElement(_ButtonRow.Button, {
	                  className: classes.orangeButton,
	                  linkUrl: "/mla",
	                  label: "MLA"
	                }),
	                _react2.default.createElement(_ButtonRow.Button, {
	                  className: classes.blueButton,
	                  linkUrl: "/mp",
	                  label: "AM"
	                }),
	                _react2.default.createElement(_ButtonRow.Button, {
	                  className: classes.redButton,
	                  linkUrl: "/td",
	                  label: "TD"
	                }),
	                _react2.default.createElement(_ButtonRow.Button, {
	                  className: classes.yellowButton,
	                  linkUrl: "/mp",
	                  label: "MEP"
	                })
	              ),
	              _react2.default.createElement(_Video2.default, {
	                name: "Caseworker.mp Video",
	                className: classes.mobileVideo,
	                src: "//www.youtube.com/embed/tKMXw7BJhck?rel=0&showinfo=0"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.mobile },
	          _react2.default.createElement(
	            _Grid.Col,
	            { middle: true, center: true },
	            _react2.default.createElement(
	              _TextSection2.default,
	              { className: classes.textBox },
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.FirstContentSection.html })
	            ),
	            _react2.default.createElement(
	              _ButtonRow2.default,
	              null,
	              _react2.default.createElement(_ButtonRow.Button, {
	                className: classes.greenButton,
	                linkUrl: "/mp",
	                label: "MP"
	              }),
	              _react2.default.createElement(_ButtonRow.Button, {
	                className: classes.purpleButton,
	                linkUrl: "/scot",
	                label: "MSP"
	              }),
	              _react2.default.createElement(_ButtonRow.Button, {
	                className: classes.orangeButton,
	                linkUrl: "/mla",
	                label: "MLA"
	              }),
	              _react2.default.createElement(_ButtonRow.Button, { className: classes.blueButton, linkUrl: "/mp", label: "AM" }),
	              _react2.default.createElement(_ButtonRow.Button, { className: classes.redButton, linkUrl: "/td", label: "TD" }),
	              _react2.default.createElement(_ButtonRow.Button, {
	                className: classes.yellowButton,
	                linkUrl: "/mp",
	                label: "MEP"
	              })
	            ),
	            _react2.default.createElement(_Video2.default, {
	              name: "Caseworker.mp Video",
	              className: classes.mobileVideo,
	              src: "//www.youtube.com/embed/tKMXw7BJhck?rel=0&showinfo=0"
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.whiteContent },
	      _react2.default.createElement(
	        "div",
	        { className: classes.container },
	        _react2.default.createElement(
	          "div",
	          { className: classes.noMobile },
	          _react2.default.createElement(
	            _Grid.Row,
	            { around: true, middle: true },
	            _react2.default.createElement(
	              _Grid.Col,
	              { middle: true, center: true },
	              _react2.default.createElement(
	                _TextSection2.default,
	                { className: classes.textBox },
	                _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentSection.html })
	              ),
	              _react2.default.createElement(
	                _ButtonRow2.default,
	                null,
	                _HomeGovButtons2.default.map(function (button) {
	                  return _react2.default.createElement(_ButtonRow.Button, {
	                    className: classes.pinkButton,
	                    linkUrl: "/gov",
	                    label: button,
	                    key: button
	                  });
	                })
	              )
	            ),
	            _react2.default.createElement(_Video2.default, {
	              name: "Caseworker.gov Video",
	              className: classes.video,
	              src: "//www.youtube.com/embed/0y_gRbWLuSM?rel=0&showinfo=0"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.mobile },
	          _react2.default.createElement(
	            _Grid.Col,
	            { middle: true, center: true },
	            _react2.default.createElement(
	              _TextSection2.default,
	              { className: classes.textBox },
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentSection.html })
	            ),
	            _react2.default.createElement(
	              _ButtonRow2.default,
	              null,
	              _HomeGovButtons2.default.map(function (button) {
	                return _react2.default.createElement(_ButtonRow.Button, {
	                  className: classes.pinkButton,
	                  linkUrl: "/gov",
	                  label: button,
	                  key: button
	                });
	              })
	            ),
	            _react2.default.createElement(_Video2.default, {
	              name: "Caseworker.gov Video",
	              className: classes.mobileVideo,
	              width: "100%",
	              height: "150%",
	              src: "//www.youtube.com/embed/0y_gRbWLuSM?rel=0&showinfo=0"
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        "div",
	        { className: classes.container },
	        _react2.default.createElement(
	          _Grid.Row,
	          { around: true },
	          _react2.default.createElement(_Video2.default, {
	            name: "Caseworker.gov Video",
	            className: classes.video,
	            width: "100%",
	            height: "150%",
	            src: "//www.youtube.com/embed/G6lXdrwwAIg?rel=0&showinfo=0"
	          }),
	          _react2.default.createElement(
	            _Grid.Col,
	            { bottom: true, center: true },
	            _react2.default.createElement(
	              _TextSection2.default,
	              { className: classes.textBox },
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.ThirdContentSection.html })
	            ),
	            _react2.default.createElement(
	              _ButtonRow2.default,
	              null,
	              _HomeVoterButtons2.default.map(function (button) {
	                return _react2.default.createElement(_ButtonRow.Button, {
	                  className: classes.yellowButton,
	                  linkUrl: "/voter",
	                  label: button,
	                  key: button
	                });
	              })
	            ),
	            _react2.default.createElement(_Video2.default, {
	              name: "Caseworker.gov Video",
	              className: classes.mobileVideo,
	              width: "100%",
	              height: "150%",
	              src: "//www.youtube.com/embed/G6lXdrwwAIg?rel=0&showinfo=0"
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	HomePage.propTypes = {
	  data: _propTypes2.default.object,
	  classes: _propTypes2.default.object,
	  route: _propTypes2.default.object
	};
	
	exports.default = (0, _reactJss2.default)(styles)(HomePage);
	
	/* global graphql */
	
	var HomeQuery = exports.HomeQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-903d7af24826f91fd7f7.js